import type { DesignTokens } from '../../theme/tokens';
import { themeCssVars } from '../../theme/cssVars';
import type { BucketKey } from './types';

/** Series colors of the dashboard, derived from the design tokens so both themes stay consistent. */
export interface DashboardPalette {
    primary: string;
    secondary: string;
    success: string;
    warning: string;
    danger: string;
    info: string;
    neutral: string;
    /** Previous-period lines and ghost columns. */
    prev: string;
    bucket: Record<BucketKey, string>;
    /** Categorical hues for the error-format donut, in rank order, and the text color that reads on each. */
    formats: string[];
    formatsLabel: string[];
    /** Text color that reads on top of each series color (`tone.*.contrast`). */
    label: { primary: string; secondary: string; success: string; warning: string; danger: string; info: string; neutral: string };
}

export const dashboardPalette = (tokens: DesignTokens): DashboardPalette => {
    const { tone, secondary, text } = tokens.color;
    return {
        primary: tone.brand.main,
        secondary: secondary.main,
        success: tone.success.main,
        warning: tone.warning.main,
        danger: tone.danger.main,
        info: tone.info.main,
        neutral: tone.neutral.main,
        prev: text.muted,
        bucket: { fast: tone.success.main, medium: tone.info.main, slow: tone.warning.main, extraSlow: tone.danger.main },
        formats: [tone.brand.main, tone.info.main, tone.success.main, tone.warning.main, tone.danger.main, secondary.main, tone.neutral.main],
        formatsLabel: [tone.brand.contrast, tone.info.contrast, tone.success.contrast, tone.warning.contrast, tone.danger.contrast, secondary.contrast, tone.neutral.contrast],
        label: {
            primary: tone.brand.contrast,
            secondary: secondary.contrast,
            success: tone.success.contrast,
            warning: tone.warning.contrast,
            danger: tone.danger.contrast,
            info: tone.info.contrast,
            neutral: tone.neutral.contrast,
        },
    };
};

/** CSS custom properties read by `styles/mockupLogsDashboard.css` and by the canvas charts. */
export const dashboardCssVars = themeCssVars;
